import { Image, ImageProps } from "@chakra-ui/react";
import Chevron from "../../resources/svg/chevron_sourcing.svg";

export const ChevronIcon = (props?: ImageProps): JSX.Element => {
  return <Image {...props} src={Chevron} />;
};

export default ChevronIcon;
